import React from "react";
import { connect } from "react-redux";
import { closeModal } from "actions/modals";
import * as allModals from "modals";
import PropTypes from "prop-types";

const ModalContainer = ({ modals, onClose }) => (
  <>
    {modals.map((modal) => {
      const Modal = allModals[modal.type];

      return (
        Modal && <Modal {...modal.props} key={modal.type} onClose={() => onClose(modal.type)} />
      );
    })}
  </>
);

ModalContainer.propTypes = {
  modals: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      props: PropTypes.object,
    })
  ),
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = ({ modals }) => ({
  modals,
});

const mapDispatchToProps = (dispatch) => ({
  onClose: (type) => dispatch(closeModal(type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);
